import { API } from "./Api";
import { Patient, Visit } from "../models/core";
import { Appointment, Encounter } from "../models/ziphy";
import { Filter, API as ZiphyAPI } from "./ZiphyAPI";
import { DateTime } from "luxon";
import { luxonToDtime } from "./time";

const MAX_RETRY_ATTEMPTS = 3;
//const CALL_DELAY = 0;

export const fetchPatient = async (pid:string, clientId:string, onComplete?:(patient?:Patient, error?:string) => void) => {
    let retries = 0;
    while(retries < MAX_RETRY_ATTEMPTS) {
        try{
            const result = await API.getPatient(clientId, pid);
            if(result) {
                onComplete && onComplete(result as Patient, undefined)
                return result;
            }
            retries += 1;
        } catch(e) {
            retries += 1;
            console.error(e)
        }
    }
    if(retries >= MAX_RETRY_ATTEMPTS) {
        onComplete && onComplete(undefined, 'Failed to retrieve Patient, try again in a few minutes')
    }
    return null;
}

export const fetchVisits = async (pid:string, clientId:string, onComplete?:(visit?:Visit[], error?:string) => void) => {
    let retries = 0;
    while(retries < MAX_RETRY_ATTEMPTS) {
        try{
            const result = await API.getVisits(clientId, pid);
            if(result) {
                onComplete && onComplete(result.items, undefined);
                return result.items;
            }
            retries += 1;
        } catch(e) {
            retries += 1;
            console.error(e)
        }
    }
    if(retries >= MAX_RETRY_ATTEMPTS) {
        onComplete && onComplete(undefined, 'Failed to retrieve Visits, try again in a few minutes');
    }
    return null;
}

/*export const fetchPatientRosters = async (pid:string, clientId:string, onComplete?:(roster?:PatientRoster[], error?:string) => void) => {
    let retries = 0;
    while(retries < MAX_RETRY_ATTEMPTS) {
        try{
            const result = await API.getRosters(clientId, pid);
            if(result) {
                onComplete && onComplete(result.items || [], undefined);
                break;
            }
            retries += 1;
        } catch(e) {
            retries += 1;
            console.error(e)
        }
    }
    if(retries >= MAX_RETRY_ATTEMPTS) {
        onComplete && onComplete(undefined, 'Failed to retrieve Patient Rosters, try again in a few minutes');
    }
    return null;
}*/


/*export const fetchPatientAppointments = async (list:boolean, zcmId:string, practiceId:number,
    visit?:Visit, onComplete?:(apt?:Appointment[], error?:string) => void) => {

    const createdDate = visit?.created ? DateTime.fromISO(visit.created)?.minus({ days: 1 }) : undefined;
    const cdDtime = createdDate ? luxonToDtime(createdDate) : undefined;

    const orFilters: Filter[] = [];

    if (visit?.appointmentId) {
        orFilters.push({ eq: ['id', visit.appointmentId] });
    }

    const andFilters: Filter[] = [
        { eq: ['practice_id', practiceId] },
        { contains: ['patient_ids', [Number.parseInt(zcmId)]] }
    ];

    if (cdDtime) {
        andFilters.push({ gte: ['appointed_start', cdDtime] });
    }

    orFilters.push({ and: andFilters });

    const filter: Filter = { or: orFilters.length > 1 ? orFilters : [orFilters[0]] };
    
    let retries = 0;
    while(retries < MAX_RETRY_ATTEMPTS) {
        try{

            if(list || !visit?.appointmentId) {
                const response = await ZiphyAPI.getAppointments(filter);
                if(response) {
                    const res = response?.appointments?.items || [];
                    onComplete && onComplete(res, undefined);
                    return res
                }
            } else {
                const response = await ZiphyAPI.getAppointment( visit?.appointmentId);
                if(response) {
                    const res = response?.appointment ? [response?.appointment] : [];
                    onComplete && onComplete(res, undefined);
                    return res
                }
            }
            retries += 1;
        } catch(e) {
            retries += 1;
            console.error(e)
        }
    }
    if(retries >= MAX_RETRY_ATTEMPTS) {
        onComplete && onComplete(undefined, 'Failed to retrieve Patient Appointments, try again in a few minutes');
    }
    return null;
}*/

export interface AppointmentEncounters {
    appointments:Appointment[];
    encounters:Encounter[];
}

export const fetchAppointmentsWithEncounters = async (zcmId:string, practiceId:number,
    visit?:Visit, onComplete?:(apt?:Appointment[], encounters?:Encounter[], error?:string) => void) => {

    const createdDate = visit?.created ? DateTime.fromISO(visit.created)?.minus({ days: 1 }) : undefined;
    const cdDtime = createdDate ? luxonToDtime(createdDate) : undefined;

    const orFilters: Filter[] = [];

    if (visit?.appointmentId) {
        orFilters.push({ eq: ['id', visit.appointmentId] });
    }

    const andFilters: Filter[] = [
        { eq: ['practice_id', practiceId] },
        { contains: ['patient_ids', [Number.parseInt(zcmId)]] }
    ];

    if (cdDtime) {
        andFilters.push({ gte: ['appointed_start', cdDtime] });
    }

    orFilters.push({ and: andFilters });

    const filter: Filter = { or: orFilters.length > 1 ? orFilters : [orFilters[0]] };
    
    let retries = 0;
    while(retries < MAX_RETRY_ATTEMPTS) {
        try{
            const response = await ZiphyAPI.getAppointmentsWithEncounters(filter);
            if(response) {
                const res = response?.appointments?.items || [];
                const ent = (response?.expanded?.encounters?.items || []).map((e) => e.value);
                onComplete && onComplete(res, ent, undefined);
                return { appointments:res, encounters:ent } as AppointmentEncounters;
            }
            retries += 1;
        } catch(e) {
            retries += 1;
            console.error(e)
        }
    }
    if(retries >= MAX_RETRY_ATTEMPTS) {
        onComplete && onComplete(undefined, undefined, 'Failed to retrieve Patient Appointments, try again in a few minutes');
    }
    return null;
}